module.exports = __webpack_public_path__ + "img/bg4.a3c3d5df.png";